module.exports = __webpack_public_path__ + "static/media/HFCHS.c55ae6d8.png";